import React, { useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { ppsiPublishedRoute, ppsiInProgressRoute } from '../../../routes';
import { getPpsisWithFilter } from '../../../features/PpsiContainer/selectors';
import Table from '../../Table/Table';
import {
  EnrichmentData,
  States
} from '../../../features/PpsiContainer/constants';
import DataTypes from '../../Table/dataTypes';
import FormContext from '../../Form/FormContext';

const pickRelatedEnrichmentData = ppsi => {
  const { id, formulaCode, formulaVersion, status } = ppsi;
  let enrichmentData;
  if (ppsi[EnrichmentData.PUBLISHED]) {
    enrichmentData = ppsi[EnrichmentData.PUBLISHED];
  } else {
    enrichmentData = ppsi[EnrichmentData.IN_PROGRESS];
  }
  return { id, formulaCode, formulaVersion, status, enrichmentData };
};

const WhereUsedColumns = {
  Formula: {
    name: 'code',
    label: 'iFood Formula',
    calculateCellValue: rowData => {
      return `${rowData.formulaCode}/${rowData.formulaVersion}`;
    },
    width: 200,
    grow: 0,
    shrink: 0
  },
  PresentationName: {
    name: 'presentationName',
    label: 'Product Name',
    dataField: 'enrichmentData.{language}.presentationName',
    translatable: true,
    link: rowData => {
      return rowData.status === States.PUBLISHED ||
        rowData.status === States.UNPUBLISHED
        ? ppsiPublishedRoute(rowData.id)
        : ppsiInProgressRoute(rowData.id);
    },
    width: 500,
  },
  ModifyDate: {
    name: 'modifyDate',
    dataField: 'enrichmentData.modifyDate',
    dataType: DataTypes.Date,
    label: 'Modify Date',
    searchable: false,
    width: 125,
    grow: 0,
    shrink: 0
  },
  ModifiedBy: {
    name: 'modifiedBy',
    dataField: 'enrichmentData.lastModifiedBy',
    label: 'Modified By',
    width: 250
  },
  Status: {
    name: 'status',
    dataField: 'enrichmentData.status',
    label: 'Status',
    width: 100
  },
  RangeCategory: {
    name: 'rangeCategory',
    dataField: 'enrichmentData.referencedIFoodData.piaProductAreaName',
    label: 'Product Area',
    filterable: true,
    width: 250
  }
};
const WhereUsedTabContent = () => {
  const { data } = useContext(FormContext);
  const relatedToPpiId = data.ppiId;
  const filter = useMemo(() => ({ relatedToPpiId }), [relatedToPpiId]);
  const ppsisWithFilter = useSelector(getPpsisWithFilter(filter)).toJS();
  const ppsis = ppsisWithFilter.map(ppsi => pickRelatedEnrichmentData(ppsi));
  return (
    <div style={{ height: '400px' }}>
      <Table
        title="ppsi.connectedPpsi"
        data={ppsis}
        columns={[
          WhereUsedColumns.Formula,
          WhereUsedColumns.PresentationName,
          // WhereUsedColumns.RangeCategory,
          WhereUsedColumns.Status
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable={false}
        toolbarVisible={false}
      />
    </div>
  );
};

export default WhereUsedTabContent;
